// extracted by mini-css-extract-plugin
export default {"login-form":"LoginForm_login-form__+b269","input-style":"LoginForm_input-style__QZjEG","btn-style":"LoginForm_btn-style__0TCEG"};